module.exports = __webpack_public_path__ + "static/media/bg2.a71882f1.jpg";